import { useContext } from 'react';
import { CommunityContext } from '../../contexts/contexts';

export const useCommunity = () => {
  const context = useContext(CommunityContext);

  if (context === undefined) {
    throw new Error('useCommunity must be used within a CommunityProvider');
  }

  const {
    feed,
    leaderboard,
    playlist,
    isFeedLoading,
    isLeaderboardLoading,
    isPlaylistLoading,
  } = context;

  return {
    feed,
    leaderboard,
    playlist,
    isFeedLoading,
    isLeaderboardLoading,
    isPlaylistLoading,
  };
};
